var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChemistry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M5.625.938c0-.518.42-.938.938-.938h16.875c.517 0 .937.42.937.938v5.625c0 .517-.42.937-.937.937H6.563a.937.937 0 0 1-.938-.937zm1.875.937v3.75h15v-3.75zM11.25 9.375c.518 0 .938.42.938.938v6.562a.94.94 0 0 1-.222.606L5.57 25.039a1.875 1.875 0 0 0 1.431 3.086H23a1.875 1.875 0 0 0 1.431-3.086l-6.396-7.558a.94.94 0 0 1-.221-.606v-6.562a.937.937 0 1 1 1.875 0v6.219l6.173 7.296A3.75 3.75 0 0 1 23 30H7a3.75 3.75 0 0 1-2.862-6.172l6.174-7.296v-6.22c0-.517.42-.937.937-.937",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChemistry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chemistry.23fc287e.svg";